import { DataManagerComponent, EventManager } from '@proteo/core';

export class CheckInvitationService {
  constructor() {}

  async acceptedInvitation(invitationId: string): Promise<any> {
    const sessionAuth = sessionStorage.getItem('identificationAuth');
    const auth = JSON.parse(sessionAuth);
    DataManagerComponent.getInstance().setAuthorization(auth);

    try {
      const response = await DataManagerComponent.getInstance().post('mobile-app/api-onboarding-bff/v0/process/invite', { invitationId });
      sessionStorage.removeItem('invitationId');
      return response.data;
    } catch (error) {
      if (error && (error as any).data && ((error as any).data as any).errorCode) {
        sessionStorage.removeItem('invitationId');
        switch (((error as any).data as any).errorCode) {
          case 'ONB-029':
            EventManager.getInstance().publish('ERROR', { error: '12' });
            break;
          case 'ONB-030':
            EventManager.getInstance().publish('ERROR', { error: '15' });
            break;
          default:
            EventManager.getInstance().publish('ERROR', { error: '8' });
            break;
        }
      } else {
        EventManager.getInstance().publish('ERROR', { error: '8' });
      }
    }
  }
}
